import axios from 'axios';

// No response means the request never reached the backend, so no log of it exists there either.
const isConnectionError = (error: unknown): boolean => axios.isAxiosError(error) && !error.response;

export default isConnectionError;
